"use strict";

var cuotaApp = function () {

  var _init = function _init() {};

  var _calc = function _calc(model) {
    var pvModelo = model.vehicle.vdisplayModelo.toLowerCase().replace(/ /, '-');
    var codcom10 = model.vehicle.vcodcom17.substring(0, 10);
    var financiacion = void 0;

    // $.ajax({
    //   cache: false,
    //   dataType: 'script',
    //   url: ``,
    //   success: function () {
    for (var i = 0; i < coches.length; i++) {
      if (coches[i].codigocomercial === codcom10) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = coches[i].financiaciones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var f = _step.value;

            if (f.codigoCF === coches[i].financiacionDefault) {
              financiacion = f;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }

    var tasa = function tasa() {
      for (var a = 0; a < financiacion.duracion.length; a++) {
        if (financiacion.duracion[a].mes === financiacion.duracionDef) return parseFloat(financiacion.duracion[a].tasa);
      }
    };
    var vr = function vr() {
      for (var a = 0; a < financiacion.vr.length; a++) {
        if (financiacion.vr[a].mes === financiacion.duracionDef) return parseFloat(financiacion.vr[a].vr);
      }
    };

    var valores = {
      "CF_tipo": parseFloat(financiacion.CF_tipo),
      "duracion": parseFloat(financiacion.duracionDef),
      "CF_current": parseFloat(financiacion.CF_tipo),
      "gastos_registro": parseFloat(financiacion.gRegistro),
      "com_presta": parseFloat(financiacion.comPresta),
      "lim_usura": parseFloat(financiacion.limUsura),
      "imp_timbre_p": parseFloat(financiacion.impTimbre),
      "imp_timbre": parseFloat(financiacion.impTimbre),
      "tasa": tasa(),
      "com_apertura_p": parseFloat(financiacion.ca),
      "com_apertura_max": 0,
      "nominal_min": parseFloat(financiacion.nominalMin),
      "nominal_max": parseFloat(financiacion.nominalMax),
      "entrada_p": parseFloat(financiacion.entradaDef),
      "entrada_min_p": parseFloat(financiacion.entradaMin),
      "entrada_max_p": parseFloat(financiacion.entradaMax),
      "s_cv_p": 0.03515,
      "s_cv_estado": parseFloat(financiacion.estadoCV),
      "s_pc_p": 0.01369,
      "s_pc_estado": parseFloat(financiacion.estadoPC),
      "s_sp_p": 0,
      "s_sp_estado": parseFloat(financiacion.estadoSP),
      "s_sa_p": 0,
      "s_sa_estado": parseFloat(financiacion.estadoSA),
      "s_cv_activo": true,
      "vr_p": vr(),
      "impuestos": parseFloat(model.prices.impuestos),
      "impuesto": (parseFloat(model.prices.impuestos) - 1) * 100,
      "impuestoMatricula": parseFloat(model.vehicle.nimpMatriculacion),
      "na": parseFloat(model.vehicle.nprecioNA),
      "transporte": parseFloat(model.vehicle.nprecioTransporte),
      "vr_tipo": financiacion.codigoVR,
      "descripcion": financiacion.descripcion,
      "perfil": "P",
      "seccion": model.vehicle.nseccionCB,
      "precioColor": parseFloat(model.prices.precioPintura),
      "precio": parseInt(model.prices.precioMostrar),
      "precioVR": parseFloat(model.prices.precioMostrar) - parseFloat(model.prices.precioPintura),
      "descuento": parseFloat(model.prices.precioDtoMostrar),
      "periodicidad": "mensual",
      "vr": 0
    };
    calcular(valores);

    return salida;

    //   },
    //   error: function (query, status, errorThrown) {
    //   },
    //   complete: function () {
    //   }
    // })
  };

  return {
    init: _init,
    calc: _calc
  };
}();